module.exports = __webpack_public_path__ + "static/img/landing2.932fb31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/landing2.png
// module id = 7rQr
// module chunks = 1